<!-- 
Dialog for triggering a reconciliation with SAP for the specified invoice.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Reconcile with SAP</v-toolbar-title>
        </v-toolbar>
        <our-busy-indicator :show="loading"/>
        <v-card-text>
          <p>
            Updates the details of this invoice using information retrieved from SAP. 
          </p>
          <p>
            This will also happen automatically every night.
          </p>
          <p v-if="lastReconciled">
            Last run <b>{{ lastReconciled | longDateTime }}</b>.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="loading" flat @click="hide">Cancel</v-btn>
          <v-btn 
            :disabled="loading"
            flat color="primary" 
            @click="reconcile"
          >
            Reconcile with SAP
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import * as action from "@/store/invoices/action-types";
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoiceId: {
      required: true,
      type: Number
    }
  },
  computed: {
    state() {
      return this.$store.state.invoices.reconcile;
    },
    loading() {
      return this.state.loading;
    },
    lastReconciled() {
      return this.$store.state.invoices.view.data.lastReconciled;
    }
  },
  methods: {
    async reconcile() {
      await this.$store.dispatch(action.RECONCILE, this.invoiceId);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
